import { render, staticRenderFns } from "./city_info.vue?vue&type=template&id=105b9b34&scoped=true&"
import script from "./city_info.vue?vue&type=script&lang=js&"
export * from "./city_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105b9b34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('105b9b34')) {
      api.createRecord('105b9b34', component.options)
    } else {
      api.reload('105b9b34', component.options)
    }
    module.hot.accept("./city_info.vue?vue&type=template&id=105b9b34&scoped=true&", function () {
      api.rerender('105b9b34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/cities/tabs/city_info.vue"
export default component.exports